import cx from "classnames";
import { CSSProperties, PropsWithChildren } from "react";
import type { DxCase, DxFontId } from "@/lib/dx-fonts";
import { dxFontVariableClass } from "@/lib/dxFontLoader";

type DigitalExhibitThemeProps = PropsWithChildren<{
  fontId: DxFontId;
  dxCase: DxCase;
  accent1?: string | null;
  accent2?: string | null;
  accent3?: string | null;
  navFontColor?: string[] | null;
}>;

// Page-level theme wrapper — exposes exhibit settings as CSS custom properties.
// Select fields arrive as single-value arrays from WPGraphQL ACF.
export default function DigitalExhibitTheme({
  children,
  fontId,
  dxCase,
  accent1,
  accent2,
  accent3,
  navFontColor,
}: DigitalExhibitThemeProps) {
  const [navColor] = navFontColor || [];

  // Nav font color — the fixed Header lives outside this wrapper, so it reads
  // the selection via body:has([data-dx-nav]) (see Header.module.scss). The
  // attribute is server-rendered here rather than set on body in an effect so
  // the nav paints in its chosen color before hydration — an effect-set
  // attribute left the nav white for the first frames of every page load
  return (
    <div
      className={cx("dx-theme", dxFontVariableClass(fontId))}
      data-dx-font={fontId}
      data-dx-case={dxCase}
      data-dx-nav={navColor || "white"}
      style={
        {
          "--dx-accent-1": accent1 || "var(--white)",
          "--dx-accent-2": accent2 || "var(--white)",
          "--dx-accent-3": accent3 || "var(--white)",
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
}
